module.exports = __webpack_public_path__ + "static/media/tallyho.98c0974c.png";